import React from 'react';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import JobCostAppIcon from 'housecall-ui/dist/IconsAndImages/AppIcons/JobCostAppIcon';

import JobCostButton from 'components/Apps/AppDetails/OtherComponents/JobCostButton';

const JobCostStrategy = {
  previewInfo: {
    name: 'Job costing',
    iconSvg: <JobCostAppIcon size="xlarge" />,
  },
  headerInfo: {
    name: 'Job costing',
    category: 'Profit & Loss',
    details: (
      <Typography variant="body1" paragraph>
        Never worry about taking a loss again with Job Costing. <br />
        With a profit and loss analysis on every job, you can make sure you always deliver on budget and protect your
        profit margin.
      </Typography>
    ),
    iconSvg: <JobCostAppIcon size="xlarge" />,
  },
  sellingPoints: {
    headline: '',
    description: '',
    orderedPoints: '',
  },
  planAvailability: {
    title: 'Housecall Pro Plan',
    description: (
      <Grid container spacing={8}>
        <Grid item xs={4}>
          <Typography align="left" variant="body1">
            Basic plan
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            Essentials plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            MAX plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
      </Grid>
    ),
  },
  price: {
    hideToggle: true,
    hideCard: true,
    appActionButton: <JobCostButton />,
  },
  supportContacts: [],
};

export default JobCostStrategy;
